import 'web-animations-js';

export default defineNuxtPlugin(() => {});
